








import { Component } from "vue-property-decorator";
import { AccountService } from "@/core/services";
import AppVue from "@/AppVue.vue";

@Component
export default class App extends AppVue {
  get layout() {
    return (this.$route.meta.layout || "default") + "-layout";
  }

  private isTokenRefreshingInProcess = false;
  async created() {
    this.$eventHub.$on("USER_UPDATED", () => {
      this.isTokenRefreshingInProcess = false;
    });

    this.$eventHub.$on("REFRESH_TOKEN", () => {
      if (!this.isTokenRefreshingInProcess) {
        this.isTokenRefreshingInProcess = true;
        AccountService.refreshToken();
      }
    });
  }
}
